var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid"}},[_c('ServerList'),_vm._v(" "),_c('ServerName'),_vm._v(" "),_c('ChannelList'),_vm._v(" "),_c('UserInfo'),_vm._v(" "),_c('ChannelInfo'),_vm._v(" "),_c('ChannelData'),_vm._v(" "),_c('UserList')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d50f586","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 98
// module chunks = 0